import moment from "moment";

const DATE_ANSWER_RE =
  /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/;
const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

const formatDateOnly = (raw) => {
  const match = raw.match(DATE_ONLY_RE);
  if (!match) return null;

  const [, yearRaw, monthRaw, dayRaw] = match;
  const parsed = moment({
    year: Number(yearRaw),
    month: Number(monthRaw) - 1,
    date: Number(dayRaw),
  });

  return parsed.isValid() ? parsed.format("DD MMM YYYY") : null;
};

export const formatDateAnswer = (value) => {
  if (typeof value !== "string") return null;

  const raw = value.trim();
  const dateOnly = formatDateOnly(raw);
  if (dateOnly) return dateOnly;

  const match = raw.match(DATE_ANSWER_RE);
  if (!match) return null;

  const parsed = moment.parseZone(raw, moment.ISO_8601, true);
  if (!parsed.isValid()) return null;

  const [, , , , hour = "00", minute = "00", second = "00", fraction = ""] = match;
  const hasTimeValue =
    Number(hour) !== 0 ||
    Number(minute) !== 0 ||
    Number(second) !== 0 ||
    Number(fraction || 0) !== 0;

  return parsed.format(hasTimeValue ? "DD MMM YYYY HH:mm" : "DD MMM YYYY");
};

export const formatAnswerValue = (value) => {
  if (value === null || value === undefined || value === "") return "N/A";

  const formattedDate = formatDateAnswer(value);
  if (formattedDate) return formattedDate;

  if (Array.isArray(value)) {
    return value.map(formatAnswerValue).join(", ");
  }

  if (typeof value === "object") {
    return Object.values(value).map(formatAnswerValue).join(", ");
  }

  return String(value);
};

export default formatAnswerValue;
